import { useEffect, useState } from "react";
import { Check, Sparkles, Images, X } from "lucide-react";
import { api } from "@/lib/api";
import { fileUrl, catOf } from "@/lib/activity";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const BannerPicker = ({ value, onChange, category }) => {
  const [banners, setBanners] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    api.get("/banners").then((r) => setBanners(r.data)).catch(() => {});
  }, []);
  const c = catOf(category);
  const selected = banners.find((b) => b.path === value);

  return (
    <div className="sm:col-span-2 space-y-2" data-testid="banner-picker">
      <p className="text-sm font-medium">Banner Kegiatan</p>
      <div className="flex items-center gap-4 rounded-2xl border border-emerald-900/10 bg-[#fcfdf9] p-3">
        <div className="w-32 sm:w-40 aspect-video rounded-xl overflow-hidden shrink-0 text-white relative" style={{ background: `linear-gradient(135deg, ${c.from}, ${c.to})` }} data-testid="banner-thumbnail">
          {value ? (
            <img src={fileUrl(value)} alt={selected?.name || "Banner"} className="h-full w-full object-cover object-center" />
          ) : (
            <span className="absolute inset-0 flex flex-col items-center justify-center text-[11px] font-semibold gap-1"><Sparkles size={14} /> Otomatis</span>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-emerald-950 truncate" data-testid="banner-selected-name">{value ? selected?.name || "Banner kustom" : `Otomatis — ${c.label}`}</p>
          <p className="text-xs text-slate-500">{value ? "Dipilih dari Perpustakaan Banner." : "Banner gradient sesuai kategori kegiatan."}</p>
          <div className="mt-2 flex flex-wrap gap-2">
            <Button type="button" size="sm" variant="outline" className="rounded-full h-8" onClick={() => setOpen(true)} data-testid="banner-change-btn"><Images size={14} className="mr-1" /> Ganti Banner</Button>
            {value && <Button type="button" size="sm" variant="ghost" className="rounded-full h-8 text-slate-500" onClick={() => onChange("")} data-testid="banner-reset-btn"><X size={14} className="mr-1" /> Gunakan Otomatis</Button>}
          </div>
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="banner-picker-dialog">
          <DialogHeader>
            <DialogTitle>Pilih Banner</DialogTitle>
            <DialogDescription>Pilih salah satu banner dari Perpustakaan Banner atau gunakan banner otomatis sesuai kategori.</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            <button type="button" onClick={() => { onChange(""); setOpen(false); }} className={`relative aspect-video rounded-xl overflow-hidden border-2 text-white ${!value ? "border-[#d4af37]" : "border-transparent hover:border-emerald-700/40"}`} style={{ background: `linear-gradient(135deg, ${c.from}, ${c.to})` }} data-testid="banner-option-auto">
              <span className="absolute inset-0 flex flex-col items-center justify-center text-xs font-semibold gap-1"><Sparkles size={16} /> Otomatis</span>
              {!value && <Check size={16} className="absolute top-1.5 right-1.5 bg-[#d4af37] text-emerald-950 rounded-full p-0.5" />}
            </button>
            {banners.map((b) => (
              <button key={b.id} type="button" onClick={() => { onChange(b.path); setOpen(false); }} title={b.name} className={`relative aspect-video rounded-xl overflow-hidden border-2 ${value === b.path ? "border-[#d4af37]" : "border-transparent hover:border-emerald-700/40"}`} data-testid={`banner-option-${b.id}`}>
                <img src={fileUrl(b.path)} alt={b.name} className="h-full w-full object-cover object-center" />
                <span className="absolute inset-x-0 bottom-0 bg-black/55 text-white text-[11px] px-2 py-1 truncate text-left">{b.name}</span>
                {value === b.path && <Check size={16} className="absolute top-1.5 right-1.5 bg-[#d4af37] text-emerald-950 rounded-full p-0.5" />}
              </button>
            ))}
          </div>
          {banners.length === 0 && <p className="text-sm text-slate-400">Belum ada banner. Unggah di tab "Perpustakaan Banner".</p>}
        </DialogContent>
      </Dialog>
    </div>
  );
};
